import {toggleMobileSideBar } from '../utils/common'
import { dropToUploadFile } from '../utils/dragAndDropUploads'
import DOMReady from '../utils/DomReady';
import { validateForm } from '../utils/ValidateForm';
import AjaxRequest from '../utils/AjaxRequest.js';

DOMReady(() => {
  
  toggleMobileSideBar()
  
  const addRemoteOptionToSelect = () => {
    const select = document.querySelector('#js-opp-country')
    const options = select && select.querySelectorAll('option')
    const remoteOption = document.createElement('option')
    let isSelected = false;

    remoteOption.innerHTML = 'Remote'
    remoteOption.setAttribute('value', 'Remote')
    select && select.prepend(remoteOption)

    options && options.forEach( option => option.hasAttribute('selected') && (isSelected = true))
    window.location.href.includes('/edit') && !isSelected && remoteOption.setAttribute('selected', '')
  }

  if (window.location.href.includes('/volunteer_opportunities')) {
    addRemoteOptionToSelect()
    dropToUploadFile()
    
    validateForm(
      document.querySelector('.js-volunteers-form'),
      {
        validations: {
          '#js-opp-title': 'required',
          '#js-opp-expertise': 'required',
          '#js-opp-country': 'required',
          '#js-opp-category': 'required',
          '#js-opp-apply-link': 'required',
          '#js-opp-url': 'required',
          '#js-opp-description': 'required',
          '#js-opp-caption': 'required'
        },
        cta: '.js-volunteers-cta'
      }
    )
    
    const ctaBtn = document.querySelector('.js-volunteers-cta')
    const form = document.querySelector('.js-volunteers-form')
  
    ctaBtn && ctaBtn.addEventListener('click', () => {
      if (!ctaBtn.classList.contains('afd-btn--not-allowed')) form && form.submit()
    })


    const remove = document.querySelectorAll('.volunteers__opportunity-delete')
    remove && remove.forEach( btn => {
      const parent = btn.closest('.volunteers__opportunity')
      const id = parent.getAttribute('data-id')
      btn.addEventListener('click', () => {
        const confirmDelete = confirm(`Are you sure you want to delete this opportunity`)
        confirmDelete && AjaxRequest(`/professionals/api/volunteer_opportunities/${id}`, { method: 'DELETE', body:{id: id}}, removeOpportunity(parent))
      })

      const removeOpportunity = (parent) => {
        parent.remove()
      }
    })
  }
})